import { render } from "./x-elevation-profile.vue?vue&type=template&id=4a149b98&scoped=true"
import script from "./x-elevation-profile.vue?vue&type=script&lang=js"
export * from "./x-elevation-profile.vue?vue&type=script&lang=js"

import "./x-elevation-profile.vue?vue&type=style&index=0&id=4a149b98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a149b98"]])

export default __exports__